module.exports = __webpack_public_path__ + "public/images/stands-logo-1@2x.4a6d9b988339060da49703b06c01ed1c.png";